const links = document.querySelectorAll( '.wp-block-media-text.is-style-video-link .wp-block-media-text__media a' );

// Credit: https://stackoverflow.com/questions/3452546/how-do-i-get-the-youtube-video-id-from-a-url
const extractYouTubeID = function( url ) {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
    var match = url.match(regExp)
    var id = (match&&match[7].length==11)? match[7] : false
    return id
}

const onPlayerReady = function( videoEvent ) {
    videoEvent.target.playVideo()
}

const closeDialog = function( dialog ) {
    dialog.classList.add( 'is-closing' )
    dialog.addEventListener( 'animationend', () => {
        dialog.classList.remove( 'is-closing' )
        dialog.close()
    }, { once: true } )
}

let youtubeAPILoaded = false
let youtubeAPILoading = false
let youtubeAPICallbacks = []

const loadYouTubeAPI = function() {

    return new Promise( ( resolve ) => {

        if ( youtubeAPILoaded ) {
            resolve()
            return
        }

        youtubeAPICallbacks.push( resolve )

        if ( youtubeAPILoading ) return

        youtubeAPILoading = true

        const tag = document.createElement( 'script' )
        tag.src = "https://www.youtube.com/iframe_api"
        const firstScriptTag = document.getElementsByTagName( 'script' )[0]
        firstScriptTag.parentNode.insertBefore( tag, firstScriptTag )

        window.onYouTubeIframeAPIReady = function() {
            youtubeAPILoaded = true
            youtubeAPICallbacks.forEach( cb => cb() )
            youtubeAPICallbacks = []
        }
        
    } )

}

const init = function() {

    if ( links.length ) {

        links.forEach( link => {

            const href = link.getAttribute( 'href' )

            if ( href && href.includes('youtube') ) {

                link.addEventListener( 'click', ( ev ) => {

                    ev.preventDefault()

                    const dialog = document.getElementById( 'videoDialog' )
                    const closeBtn = dialog.querySelector( '.apm-dialog__close' )
                    var   player

                    loadYouTubeAPI().then( () => {
                        player = new YT.Player( 'dialogVideoContainer', {
                            height: '390',
                            width: '640',
                            videoId: extractYouTubeID(href),
                            playerVars: {
                                'playsinline': 1
                            },
                            events: {
                                'onReady': onPlayerReady
                            }
                        } )
                    } )

                    dialog.showModal()

                    // Close on close button click
                    closeBtn.addEventListener( 'click', () => {
                        closeDialog( dialog )
                    }, { once: true } )

                    // Close on backdrop click
                    dialog.addEventListener( 'click', ( e ) => {
                        if ( e.target === dialog ) {
                            closeDialog( dialog )
                        }
                    } )

                    // Close on escape key with animation
                    dialog.addEventListener( 'cancel', ( e ) => {
                        e.preventDefault()
                        closeDialog( dialog )
                    } )

                    // Destroy player when dialog closes
                    dialog.addEventListener( 'close', () => {
                        if ( player ) player.destroy()
                    }, { once: true } )

                    return false

                } )

            }

        } );

    }

};

const api = {
	init: init
};

export default api;